import { Input } from "antd";
import { ReactComponent as CloseSvg } from './icons/close.svg';
import { ReactComponent as UploadSvg } from './icons/upload-model.svg';
import "./upload-record-modal.less"
import { getDateDetailName } from "@/global/utils/date-utils";
import { useContext, useEffect, useState } from "react";
import { DeviceInstallHistory, Sensor } from "@/global/interface/device/sensor";
import { DataBox } from "@/global/interface/device/data-box";
import { ProjectFile } from "@/global/interface/project-manage/project-file";
import { UploadFileContext } from "@/App";
import { UploadFileLocale, FileUploadParam } from "tncet-common";
import { useParams } from "react-router";
import { addSensorInstallHistory, updateSensor } from "@/api/device/sensor";
import TnMessage from "@/global/components/message";
import { addDataBoxInstallHistory, updateDataBox } from "@/api/device/data-box";

interface Iprops {
    setVisible: (e) => void,
    sensor?: Sensor,
    dataBox?: DataBox
}

export default function UploadRecordModal(props: Iprops) {

    const { sensor, dataBox } = props
    const { projectId } = useParams()
    const [installTime, setInstallTime] = useState<number>()
    const [phone, setPhone] = useState<number>(13333333333)
    const [person, setPerson] = useState<string>("用户")
    // 传感器参数
    const [channel, setChannel] = useState<string>("")
    // 采集箱参数
    const [imei, setImei] = useState<string>("")
    // 通用参数
    const [addressCode, setAddressCode] = useState<string>("")
    // 文件上传
    const [uploadFileList, setUploadFileList] = useState([]);
    const [md5Value, setMd5Value] = useState<string>()
    const [file, setFile] = useState<ProjectFile>()
    const uploadFileContext = useContext(UploadFileContext);

    useEffect(() => {
        if (!(sensor || dataBox)) return
        // 安装时间
        setInstallTime(Date.now())
        // 地址
        setAddressCode(sensor?.addressCode || dataBox?.addressCode || "")
        // 通道号
        setChannel(sensor?.channel || "")
        // imei码
        setImei(dataBox?.imei || "")
        // 清空文件上传
        setUploadFileList([])
        setFile(null)
        setMd5Value(null)
        // todo 获取并设置用户相关字段：phone, person
    }, [sensor, dataBox])

    const handleFileChange = (e) => {
        const newFileList = Array.from(e.target.files);
        beforeUpload(null, newFileList);
    };

    const beforeUpload = (file, fileList) => {
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    useEffect(() => {
        if (!uploadFileContext.visible && uploadFileList.length > 0) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    const uploadCallbackFn = (uploadFile: FileUploadParam) => {
        return new Promise(resolve => {
            let data: ProjectFile = {
                ...uploadFile,
                projectId: +projectId,
            }
            setFile(data)
            setMd5Value(data.md5)
            resolve(true)
        })
    }

    const onSaveClick = () => {
        let addValue: DeviceInstallHistory = {
            installTime: installTime,
            installPerson: person,
            phone: phone.toString(),
            installObject: "",
            position: "",
            md5: md5Value,
            file: file
        }


        if (sensor) {
            // 判断有没有修改字段
            let newData = {}
            if (addressCode != sensor?.addressCode) {
                if (!(addressCode?.length == 0 && !sensor?.addressCode)) {
                    newData["addressCode"] = addressCode
                }
            }
            if (channel != sensor.channel) {
                if (!(channel?.length == 0 && !sensor.channel)) {
                    newData["channel"] = channel
                }
            }
            updateSensor(sensor.id, newData).catch(e => {
                TnMessage.error("更新失败！")
                return
            })
            addSensorInstallHistory(Number(projectId), sensor.id, addValue).then(res => {
                props.setVisible(false)
                TnMessage.success("添加成功")
            }).catch(e => {
                TnMessage.error("添加失败！")
            })
        } else if (dataBox) {
            // 判断有没有修改字段
            let newData = {}
            if (addressCode != dataBox?.addressCode) {
                if (!(addressCode?.length == 0 && !dataBox?.addressCode)) {
                    newData["addressCode"] = addressCode
                }
            }
            if (imei != dataBox?.imei) {
                if (!(imei?.length == 0 && !dataBox?.imei)) {
                    newData["imei"] = imei
                }
            }
            updateDataBox(dataBox.id, newData).catch(e => {
                TnMessage.error("更新失败！")
                return
            })
            addDataBoxInstallHistory(Number(projectId), dataBox.id, addValue).then(res => {
                props.setVisible(false)
                TnMessage.success("添加成功")
            }).catch(e => {
                TnMessage.error("添加失败！")
            })
        }
    }

    return (
        <div className="upload-model-main">
            <div className='title'>
                <div className='name'>
                    {"上传记录"}
                </div>
                <div className='icon' onClick={() => { props.setVisible(false) }}>
                    <CloseSvg />
                </div>
            </div>
            <div className="body">
                <div className="body-item">
                    <div className="item">
                        <div className="label">
                            设备编号
                        </div>
                        <div className="input">
                            <div className="input-value">
                                {sensor?.code || dataBox?.code || ""}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="label">
                            设备名称
                        </div>
                        <div className="input">
                            <div className="input-value">
                                {sensor?.name || dataBox?.name || ""}
                            </div>
                        </div>
                    </div>
                    <div className="picture-item">
                        <div className="picture-label">
                            上传图片
                        </div>
                        <div className="picture-area">
                            <div className="btn" onClick={() => document.getElementById('upload-record-modal-input').click()}>
                                <UploadSvg />
                            </div>
                            {file ? (file?.name + file?.suffix) : ""}
                            <input style={{ display: "none" }} id="upload-record-modal-input" type="file" onChange={handleFileChange} multiple accept="image/*" />
                        </div>
                    </div>
                    <div className="item">
                        <div className="label">
                            安装时间
                        </div>
                        <div className="input">
                            {getDateDetailName(installTime)}
                        </div>
                    </div>
                    <div className="item">
                        <div className="label">
                            安装人员
                        </div>
                        <div className="input">
                            {person}
                        </div>
                    </div>
                    <div className="item">
                        <div className="label">
                            电话
                        </div>
                        <div className="input">
                            {phone}
                        </div>
                    </div>
                </div>
                <div className="body-item">
                    {sensor && (
                        <>
                            <div className="item">
                                <div className="label">
                                    传感器地址码
                                </div>
                                <div className="input">
                                    <Input
                                        value={addressCode}
                                        onChange={(e) => { setAddressCode(e.target.value) }}
                                        size="small"
                                    />
                                </div>
                            </div>
                            <div className="item">
                                <div className="label">
                                    通道编号
                                </div>
                                <div className="input">
                                    <Input
                                        value={channel}
                                        onChange={(e) => { setChannel(e.target.value) }}
                                        size="small"
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {dataBox && (
                        <>
                            <div className="item">
                                <div className="label">
                                    采集箱地址码
                                </div>
                                <div className="input">
                                    <Input
                                        value={addressCode}
                                        onChange={(e) => { setAddressCode(e.target.value) }}
                                        size="small"
                                    />
                                </div>
                            </div>
                            <div className="item">
                                <div className="label">
                                    imei码
                                </div>
                                <div className="input">
                                    <Input
                                        value={imei}
                                        onChange={(e) => { setImei(e.target.value) }}
                                        size="small"
                                    />
                                </div>
                            </div>
                        </>
                    )}


                </div>

            </div>

            <div className='button-area'>
                <div className="cancel" onClick={() => { props.setVisible(false) }}>
                    {"取消"}
                </div>
                <div className="save" onClick={() => { onSaveClick() }}>
                    {"确认"}
                </div>
            </div>

        </div>
    )
}